import cx from 'classnames';
import { Features, VariantAttributesWithOptions } from 'mk2/apps/strollers/schemas';
import React from 'react';
import styles from './FeatureItem.mscss';

interface OwnProps {
    feature: any;
    features: Partial<Features | VariantAttributesWithOptions>;
    even?: boolean;
    className?: string;
}

type Props = OwnProps;

export class FeatureItem extends React.Component<Props> {

    public static defaultProps: Partial<OwnProps> = {
        even: false,
    };

    public render() {
        const { even, feature, features} = this.props;

        const className = cx(
            styles.FeatureItem,
            even ? styles['FeatureItem--even'] : styles['FeatureItem--odd'],
            this.props.className,
        );

        const label = feature.getLabelMessage();
        const ValueComponent = feature.Component;

        return (
            <div className={className}>
                <div className={styles.FeatureItem__label}>
                    {label}
                </div>
                <ValueComponent features={features} feature={feature} />
            </div>
        );
    }
}
